import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-86794818"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "tablebox"
};

var _hoisted_2 = /*#__PURE__*/_createTextVNode(" 下载 ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_table_column = _resolveComponent("el-table-column");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_table = _resolveComponent("el-table");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.tableData.length > 0 ? (_openBlock(), _createBlock(_component_el_table, {
    key: 0,
    style: {
      "width": "100%"
    },
    data: _ctx.tableData,
    "empty-text": "暂无数据",
    border: true
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_table_column, {
        prop: "realName",
        label: "文件名",
        width: "600"
      }), _createVNode(_component_el_table_column, {
        label: "操作"
      }, {
        default: _withCtx(function (scoped) {
          return [_createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: function onClick($event) {
              return _ctx.downUrl(scoped.row.attachmentId);
            }
          }, {
            default: _withCtx(function () {
              return [_hoisted_2];
            }),
            _: 2
          }, 1032, ["onClick"])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["data"])) : _createCommentVNode("", true)]);
}